import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'
import { BootstrapVue, IconsPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App'
import router from './router'
import store from './store'
import { hasPermission } from './components/permission/hasPermission'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  precision: 2
})

Vue.use(VueTheMask)

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.event = function (event) {
      vnode.context[binding.expression](event)
    }
    document.addEventListener('click', el.event)
  },
  unbind: function (el) {
    document.removeEventListener('click', el.event)
  }
})

Vue.directive('has-permission', {
  inserted: function (el, binding, vnode) {
    if (!hasPermission(binding.value)) {
      vnode.elm.parentElement.removeChild(vnode.elm)
    }
  }
})

Vue.filter('formatNumberZero', function (value) {
  if (value > -1) {
    return numeral(value).format('0.00')
  }
})

Vue.filter('formatNumber', function (value) {
  if (value > -1) {
    return numeral(value).format('0');
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment.utc(value).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatTimestamp', function (value) {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm:ss')
  }
})

Vue.filter('formatHour', function (value) {
  if (value) {
    const hour = /(\d{2}:\d{2}:\d{2})/g.exec(value)
    console.log(hour, value)
    if (hour && hour.length > 0) {
      return hour[0]
    } else {
      return moment(value).format('LTS')
    }
  }
})

new Vue({
  store,
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// /src/main.js